/**
 * Chatwoot's ActionCable endpoint. After a hand-off, team replies arrive over
 * this socket; without it a chat falls back to polling `/messages` every 5 s
 * (and the widget reports the degraded transport to Sentry). Both chat
 * surfaces read it from here: the site widget and the quiz chat.
 */
export const CHATWOOT_WS_BASE =
  process.env.NEXT_PUBLIC_CHATWOOT_WS_BASE ?? "wss://chat.aheadhealth.dev"
